import React from 'react';
import * as cls from './smarter-way.module.css';
import { Typography } from '../../../ui/components/typography';
import { Section } from '../../../ui/components/section';
import { IMG_PATH } from '../../../constants';

const items = [
  {
    icon: 'smarter-way-1.png',
    title: 'Cut waste by 2-10%',
    description: (
      <>
        Households using energy monitoring tools typically reduce electricity
        use by 2-10% per year.
        <br />
        <i>Source: BEAMA field trials</i>
      </>
    ),
  },
  {
    icon: 'smarter-way-2.png',
    title: 'Save £147/year on standby power',
    description: (
      <>
        Voltaware helps you spot appliances silently draining power even when
        "off."
        <br />
        <i>Source: Sensorfact, UK estimates</i>
      </>
    ),
  },
  {
    icon: 'smarter-way-3.png',
    title: ' Monitor in real-time and save with the Voltaware app',
    description: (
      <>
        Real-time energy feedback can reduce electricity bills by 3–4%.
        <br />
        <i>Source: Behavioural Insights Team, GB smart meter study</i>
      </>
    ),
  },
];

export const SmarterWay = () => {
  return (
    <Section>
      <Typography as="h1" tag="h2">
        A Smarter Way to Save on Your Energy Bills
      </Typography>

      <div className={cls.wrapper}>
        {items.map((item, index) => (
          <div className={cls.item} key={index}>
            <img alt="" src={`${IMG_PATH}/amazon-shop/${item.icon}`} />
            <Typography as="h4">{item.title}</Typography>
            <Typography>{item.description}</Typography>
          </div>
        ))}
      </div>
    </Section>
  );
};
